import { __awaiter, __generator } from "tslib";
export function getIsTestEnv(officeComponentContextPromise) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, deploymentEnvironment, inMockMode;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, officeComponentContextPromise];
                case 1:
                    _a = _b.sent(), deploymentEnvironment = _a.deploymentEnvironment, inMockMode = _a.inMockMode;
                    return [2 /*return*/, inMockMode || deploymentEnvironment === "ppe" /* OfficeEnvironment.PPE */];
            }
        });
    });
}
//# sourceMappingURL=getIsTestEnv.js.map